module.exports = __webpack_public_path__ + "img/canvas-frame-lg.6a15b14.svg";